import React, { useState } from "react";
import SideMenuLogo from "assets/Icons/icons/Logo";
import sidebarImg from "../../assets/images/Side bar.webp";
import axios from "axios";

const AppForm = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        organization: "",
        role: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};
        if (!formData.firstName) newErrors.firstName = "First Name is required";
        if (!formData.lastName) newErrors.lastName = "Last Name is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.organization)
            newErrors.organization = "Organization is required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Request Payload
        const payload = {
            form: "contact",
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            organization: formData.organization,
            role: formData.role || "Not specified",
        };

        try {
            const response = await axios.post(
                process.env.REACT_APP_FORM_URL,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                alert("Form submitted successfully!");
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    organization: "",
                    role: "",
                });
                setErrors({});
            } else {
                alert("Error submitting the form. Please try again.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("Network error. Please check your internet connection.");
        }
    };

    return (
        <div className="flex w-full min-h-screen">
            <div className="pt-10 pb-8 w-1/2 min-h-screen">
                <div className="px-10">
                    <SideMenuLogo />
                </div>
                <div className="px-[124px] mt-[90px] flex-grow">
                    <h1 className="font-semibold text-[20px] leading-7 text-[#262626]">
                        Help Us Improve the Plugin
                    </h1>
                    <p className="mt-4 mb-6 text-[#454545] text-[15px] leading-6">
                        Try out the redesigned interface and share your
                        feedback. Your <br /> insights will help us refine the
                        experience and make it even better!
                    </p>
                    <div className="flex-grow flex flex-col justify-between">
                        <div>
                            <form
                                onSubmit={handleSubmit}
                                className="space-y-4 text-[#595959] text-[15px] leading-6"
                            >
                                {/* First Name */}
                                <div>
                                    <label className="block font-medium">
                                        First Name*
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-[#D1D5DB] rounded-lg h-11"
                                    />
                                    {errors.firstName && (
                                        <p className="text-red-500 text-sm">
                                            {errors.firstName}
                                        </p>
                                    )}
                                </div>

                                {/* Last Name */}
                                <div>
                                    <label className="block font-medium">
                                        Last Name *
                                    </label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-[#D1D5DB] rounded-lg h-11"
                                    />
                                    {errors.lastName && (
                                        <p className="text-red-500 text-sm">
                                            {errors.lastName}
                                        </p>
                                    )}
                                </div>

                                {/* Email */}
                                <div>
                                    <label className="block font-medium">
                                        Email *
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-[#D1D5DB] rounded-lg h-11"
                                    />
                                    {errors.email && (
                                        <p className="text-red-500 text-sm">
                                            {errors.email}
                                        </p>
                                    )}
                                </div>

                                {/* Organization */}
                                <div>
                                    <label className="block font-medium">
                                        Organization *
                                    </label>
                                    <input
                                        type="text"
                                        name="organization"
                                        value={formData.organization}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-[#D1D5DB] rounded-lg h-11"
                                    />
                                    {errors.organization && (
                                        <p className="text-red-500 text-sm">
                                            {errors.organization}
                                        </p>
                                    )}
                                </div>
                                {/* Role (Optional) */}
                                <div>
                                    <label className="block font-medium">
                                        Your Role
                                    </label>
                                    <select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-[#D1D5DB] rounded-lg"
                                    >
                                        <option value="">Select a role</option>
                                        <option value="Developer">
                                            Developer
                                        </option>
                                        <option value="Manager">Manager</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                {/* Privacy Policy */}
                                <p className="text-[13px] leading-5">
                                    By submitting this form, you agree to
                                    receive communications from Alluvium. See
                                    our{" "}
                                    <a href="#" className="text-[#E37915]">
                                        Privacy Policy
                                    </a>{" "}
                                    for details.
                                </p>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className="w-full p-3 bg-[#E37915] text-white font-semibold rounded-lg"
                                >
                                    Submit
                                </button>
                            </form>
                        </div>
                        {/* Footer  */}
                        <div className="font-medium text-[14px] leading-5 text-[#595959] mt-[144px]">
                            <p>© 2022 Alluvium Corporation.</p>
                            <p className="mt-2">
                                <span className="underline">
                                    Terms & Conditions
                                </span>
                                <span className="underline ml-4">
                                    Privacy Policy
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-1/2 p-2">
                <img
                    src={sidebarImg}
                    alt="webpp"
                    className="w-full h-full object-cover"
                />
            </div>
        </div>
    );
};

export default AppForm;
